import React, { Component, Fragment } from 'react';
import {connect} from 'react-redux';
import moment from 'moment';
import { ContextMenu, MenuItem, ContextMenuTrigger } from "react-contextmenu";

import {Config} from '../../util';
import BigCard from './BigCard';
import SmallCard from './SmallCard';
import NormalCard from './NormalCard';



class Card extends Component {
  constructor(props){
    super(props);

    this.handleClick = this.handleClick.bind(this);
    this.handleContextMenuClick = this.handleContextMenuClick.bind(this);
    this.handleDetailMenuClick = this.handleDetailMenuClick.bind(this);
    this.handleOnMouseEnter = this.handleOnMouseEnter.bind(this);
    this.handleOnMouseLeave = this.handleOnMouseLeave.bind(this);
    this.state = {
      displayToolTip: false,
    }
  }
  componentDidMount(){
  }
  shouldComponentUpdate(nextProps, nextStates){
    if(this.props.duration !== nextProps.duration
      && this.props.start !== nextProps.start){
        return true;
      }
    if(this.state.displayToolTip !== nextStates.displayToolTip){
      return true;
    }
    if(this.props.active !== nextProps.active){
      return true;
    }
    if(this.props.selectedMenu !== nextProps.selectedMenu){
      return true;
    }
    return false;
  }
  
 


  handleClick(event, data) {
    const options = Object.assign({}, this.props);
    options.start = moment(options.start, 'YYYYMMDDHHmmss');
    options.stop = moment(options.stop, 'YYYYMMDDHHmmss');
    delete options.onClick;
    delete options.onContextMenuClick;
    if(typeof this.props.onClick === 'function'){
      this.props.onClick(options);
    }
  }

  handleContextMenuClick(event, data) {
    const options = Object.assign({}, this.props);
    delete options.onClick;
    delete options.onContextMenuClick;
    options.data = data.item;

    if(typeof this.props.onContextMenuClick === 'function'){
      this.props.onContextMenuClick(options);
    }
  }

  handleDetailMenuClick(event){
    const options = Object.assign({}, this.props);
    if(typeof this.props.onDetailClick === 'function'){
      this.props.onDetailClick(options);
    }
  }

  handleOnMouseEnter(){
    this.setState({displayToolTip: true})
  }
  handleOnMouseLeave(){
    this.setState({displayToolTip: false})
  }


  render() {
    const options = Object.assign({}, this.props);
    const htmlId = `card_${options.epgid}_${options.start}`;
    options.start = moment(options.start, 'YYYYMMDDHHmmss');
    options.stop = moment(options.stop, 'YYYYMMDDHHmmss');
    options.duration = options.stop.diff(options.start, 'minutes');
    options.color = options.bgColor && options.active ? options.bgColor : '#fff';
    options.thumbnail = options.img && options.active ? options.img : false;
    options.onClick = this.handleClick;

    let renderComponent = <div/>;
    
    const {displayToolTip} = this.state;


    if(options.duration < 40){
      options.onDobbleClick = this.handleClick;
      renderComponent = (
        <ContextMenuTrigger id={htmlId} holdToDisplay={-1} key={htmlId} disable={!options.active}>
          <SmallCard {...options}/>
        </ContextMenuTrigger>
      );
    // } else if (options.duration < 51) {
    //   options.onDobbleClick = this.handleClick;
    //   renderComponent = (
    //     <ContextMenuTrigger id={htmlId} holdToDisplay={-1} key={htmlId} disable={!options.active}>
    //       <NormalCard {...options}/>
    //     </ContextMenuTrigger>
    //   );
    } else if (options.duration) {
      options.onDobbleClick = this.handleClick;
      renderComponent = (
        <ContextMenuTrigger id={htmlId} holdToDisplay={-1} key={htmlId} disable={!options.active}>
          <BigCard {...options}/>
        </ContextMenuTrigger>
      );
    }
    const data = Object.assign({}, options);
    delete data.onClick;

    const isMenuItemName = !Config.isPreviewMenuName && Config.logoUrl && Config.logoUrl.length > 0; 
    const {selectedMenu, onDetailClick} = this.props;

    return [
      renderComponent,
      <ContextMenu id={htmlId} className='react-contextmenu-custom' key={`${htmlId}_contextmenu`} >
        {(selectedMenu === "SCHEDULE" || selectedMenu === "SEARCH") &&
          <Fragment>
            <MenuItem onClick={this.handleDetailMenuClick} data={{ item: 'Popup' }}>Detail View</MenuItem>
            <MenuItem divider />
          </Fragment>
        }
        <MenuItem onClick={this.handleContextMenuClick} data={{ item: 'Video1' }}>{isMenuItemName ? Config.logoUrl[0].id : "Preview1"}</MenuItem>
        <MenuItem onClick={this.handleContextMenuClick} data={{ item: 'Video2' }}>{isMenuItemName ? Config.logoUrl[1].id : "Preview2"}</MenuItem>
        <MenuItem onClick={this.handleContextMenuClick} data={{ item: 'Video3' }}>{isMenuItemName ? Config.logoUrl[2].id : "Preview3"}</MenuItem>
        <MenuItem onClick={this.handleContextMenuClick} data={{ item: 'Video4' }}>{isMenuItemName ? Config.logoUrl[3].id : "Preview4"}</MenuItem>
      </ContextMenu>
    ];
  }
}

const mapStateToProps = (state) => {
  return {
    selectedMenu: state.selectedMenu
  }
};

Card = connect(mapStateToProps)(Card);

export default Card;


// WEBPACK FOOTER //
// ./src/components/card/index.js